import React, { useRef } from "react";
import PortalModal from "../../Portals";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  TextModalActiveSurvey,
  ButtonActiveSurvey,
  ButtonActiveSurveyCancel,
  ContentModal,
  ActionButtons,
} from "./ModalSaveTemplate.styled";
import { SAVE_SURVEY_AS_TEMPLATE } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import { useMutation } from "@apollo/client";

const ModalSaveTemplate = ({
  surveyId,
  isSavedAsTemplate,
  setIsSavedAsTemplate,
  setModalVisibility,
  renderTemplateList,
  setRenderTemplateList,
}) => {
  const [saveSurveyTemplate] = useMutation(SAVE_SURVEY_AS_TEMPLATE);
  const refTemplateName = useRef("");

  const handleSaveTemplate = () => {
    if (refTemplateName?.current?.value) {
      setModalVisibility(false);
      saveSurveyTemplate({
        variables: {
          surveyId: surveyId,
          templateName: refTemplateName?.current?.value,
        },
      })
        .then((response) => {
          if (!response.data.saveAsTemplate.withError) {
            setIsSavedAsTemplate(!isSavedAsTemplate);
            NotificationManager.success(
              "Survey saved as template successfully",
              "",
              5000
            );
          }
          setRenderTemplateList(!renderTemplateList);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning("Please enter the name", "", 5000);
    }
  };

  return (
    <PortalModal>
      <ContentModal>
        <ContentModalActiveSurvey>
          <CloseModalActiveSurvey>
            <Tooltip title="close">
              <IconButton>
                <CloseIcon onClick={() => setModalVisibility(false)} />
              </IconButton>
            </Tooltip>
          </CloseModalActiveSurvey>
          <TextModalActiveSurvey>
            <p>Type the name of your template</p>
            <input
              placeholder="Template Name"
              type="text"
              ref={refTemplateName}
            />
          </TextModalActiveSurvey>
          <ActionButtons>
            <ButtonActiveSurvey
              onClick={() => {
                handleSaveTemplate();
              }}
            >
              Save
            </ButtonActiveSurvey>
            <ButtonActiveSurveyCancel onClick={() => setModalVisibility(false)}>
              Cancel
            </ButtonActiveSurveyCancel>
          </ActionButtons>
        </ContentModalActiveSurvey>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalSaveTemplate;
